import { render, staticRenderFns } from "./LanscapeIcon.vue?vue&type=template&id=384dc16c&scoped=true&"
import script from "./LanscapeIcon.vue?vue&type=script&lang=ts&"
export * from "./LanscapeIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LanscapeIcon.vue?vue&type=style&index=0&id=384dc16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384dc16c",
  null
  
)

export default component.exports